import React from "react";
import { Text } from "@jsq/ds/core";
import * as styles from "./styles_vanilla.css";
import type { InvestmentEntityGridRow } from "../../types";

interface EntitySummaryProps {
  /** Entity data to display */
  entity: InvestmentEntityGridRow;
}

/**
 * Entity Summary Sidebar - displays entity information and metadata.
 */
export const EntitySummary: React.FC<EntitySummaryProps> = ({ entity }) => {
  return (
    <div className={styles.entitySummary} data-testid="entity-summary">
      <div className={styles.summarySection}>
        <Text variant="regular-lg" className={styles.entityName}>
          {entity.name}
        </Text>
      </div>

      <div className={styles.summarySection}>
        <div className={styles.summaryField}>
          <Text variant="regular-sm" className={styles.fieldLabel}>
            Entity ID
          </Text>
          <Text variant="regular-md" className={styles.summaryFieldValue}>
            {entity.id}
          </Text>
        </div>

        <div className={styles.summaryField}>
          <Text variant="regular-sm" className={styles.fieldLabel}>
            Status
          </Text>
          <Text variant="regular-md" className={styles.summaryFieldValue}>
            {entity.status}
          </Text>
        </div>

        {entity.type && (
          <div className={styles.summaryField}>
            <Text variant="regular-sm" className={styles.fieldLabel}>
              Type
            </Text>
            <Text variant="regular-md" className={styles.summaryFieldValue}>
              {entity.type.name}
            </Text>
          </div>
        )}

        <div className={styles.summaryField}>
          <Text variant="regular-sm" className={styles.fieldLabel}>
            Partial Entity
          </Text>
          <Text variant="regular-md" className={styles.summaryFieldValue}>
            {entity.isPartial ? "Yes" : "No"}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default EntitySummary;
